import { useCallback, useState } from 'react';

import { Permission, usePermission } from '@bonusly/who-am-i';

import { useSpotlightEligibilityDefault } from '../../../queries/employee-spotlights';
import { SpotlightGenerationEntryPoint } from './use-spotlight-generation-analytics';

interface UseSpotlightMenuActionParams {
	userId: string;
	displayName: string;
	entryPoint: SpotlightGenerationEntryPoint;
}

/**
 * Encapsulates per-user spotlight eligibility check + modal state for action menus.
 * Only fetches eligibility when the user has CanAccessSpotlights permission.
 */
export const useSpotlightMenuAction = ({ userId, displayName, entryPoint }: UseSpotlightMenuActionParams) => {
	const canAccessSpotlight = usePermission(Permission.CanAccessSpotlight);
	const { data: eligibility } = useSpotlightEligibilityDefault(userId, { enabled: canAccessSpotlight });
	const isEligible = canAccessSpotlight && eligibility?.eligible === true;

	const [isModalOpen, setIsModalOpen] = useState(false);

	const openModal = useCallback(() => setIsModalOpen(true), []);
	const closeModal = useCallback(() => setIsModalOpen(false), []);

	return {
		isEligible,
		isModalOpen,
		openModal,
		closeModal,
		targetUserId: userId,
		targetUserName: displayName,
		entryPoint,
	};
};
